import React, { useState, forwardRef } from "react";
import { InputText } from "primereact/inputtext";
import PropTypes from "prop-types";
import "./PasswordInput.css";

/**
 * Custom password input with working toggle visibility icon.
 * Uses plain CSS positioning instead of broken PrimeReact Password component.
 */
const PasswordInput = forwardRef(
  (
    { value, onChange, disabled, inputId, autoFocus, tabIndex, ...rest },
    ref,
  ) => {
    const [visible, setVisible] = useState(false);

    const toggleVisibility = (e) => {
      e.preventDefault();
      if (!disabled) {
        setVisible((prev) => !prev);
      }
    };

    return (
      <div className="custom-password-wrapper">
        <InputText
          ref={ref}
          id={inputId}
          type={visible ? "text" : "password"}
          value={value}
          onChange={onChange}
          disabled={disabled}
          autoFocus={autoFocus}
          tabIndex={tabIndex}
          className="custom-password-input"
          {...rest}
          data-evo-id="passwordinput-input-password"
        />
        <button
          type="button"
          className="custom-password-toggle"
          onClick={toggleVisibility}
          disabled={disabled}
          tabIndex={-1}
          aria-label={visible ? "Ocultar senha" : "Mostrar senha"}
          data-evo-id="passwordinput-btn-toggle-visibility"
        >
          <i className={`pi ${visible ? "pi-eye-slash" : "pi-eye"}`} />
        </button>
      </div>
    );
  },
);

PasswordInput.displayName = "PasswordInput";

PasswordInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  inputId: PropTypes.string,
  autoFocus: PropTypes.bool,
  tabIndex: PropTypes.number,
};

export default PasswordInput;
